import { useEffect } from 'react'
import StorefrontCategoryTree, {
	StorefrontCategoryTreeItem,
	StoreFrontFilterItemTreeItem,
} from '@local-types/categoryTrees/storefrontCategoryTree'

export const useScrollToTopOnFirstPage = (page: number) => {
	useEffect(() => {
		if (page === 1)
			window.scrollTo({
				top: 250,
				behavior: 'smooth',
			})
	}, [page])
}

export const getActiveMainTreeFilter = (path: string[], tree: StorefrontCategoryTree | null | undefined) => {
	const drillPath = [...path]
	let item: StoreFrontFilterItemTreeItem = tree

	while (drillPath.length > 0) {
		const idOrSlug = drillPath.shift()
		if (!idOrSlug) continue
		item = item?.children?.find(x => x.categoryId === idOrSlug || x.slug === decodeURI(idOrSlug)) || item
	}

	return {
		item,
		isRoot: path.length === 0,
	}
}

export const getActiveDisplayTreeFilter = (path: string[], tree: StorefrontCategoryTree | null | undefined) => {
	const drillPath = [...path]
	let item: StoreFrontFilterItemTreeItem = tree

	while (drillPath.length > 0) {
		const idOrSlug = drillPath.shift()
		if (!idOrSlug) continue
		const nextChild: StoreFrontFilterItemTreeItem = item?.children?.find(
			x => x.categoryId === idOrSlug || x.slug === decodeURI(idOrSlug)
		)
		if (nextChild?.children && nextChild?.children.length !== 0) {
			item = nextChild || item
		}
	}

	return {
		item,
		isRoot: path.length === 0,
	}
}

export const getActiveMustIncludeTreeFilters = (
	path: string[],
	trees: StorefrontCategoryTree[]
): StorefrontCategoryTreeItem | null => {
	const drillPath = [...path]
	let item: StoreFrontFilterItemTreeItem | null = null

	while (drillPath.length > 0) {
		const idOrSlug = drillPath.shift()
		if (!idOrSlug) continue
		for (let i = 0; i < trees.length; i++) {
			item = trees[i].children.find(x => x.categoryId === idOrSlug || x.slug === decodeURI(idOrSlug)) || item
		}
	}

	return item as StorefrontCategoryTreeItem
}
